
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';

/**
 *
 * @class RejectedPossibleBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      May 2021
 *
 */
export class RejectedPossibleBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    return {
      id:          data.id,
      seq:         data.index,
      name:        `${data.text}`,
      hasChildren: false,
      isExpanded:  false,
      type:        'rejected-possible-move',
      children:    [],
      parent:      args.parent,
      kids:        data.kids,
      tags:        data.tags,
      label:       data.label,
      pkey:        data.pkey,
      text:        data.text,
      from:        data.from,
      to:          data.to,
      next:        data.next,
      reason:      data.reason,
      u:           data.u

    };

  }
}
